import React, { useState } from "react";
import LocationDialog from "./location_dialog";
import { TextInput } from "@mantine/core";

const InputLocation = ({ onChange, name, variant = "default", value, label }) => {
    const [choosingLocation, setChoosingLocation] = useState<any>(null);

    const handleChooseLocation = () => {
        let { place } = choosingLocation;
        setChoosingLocation(null);
        onChange && onChange({[name]: place})
    }

    return <div>
        <TextInput
            label={label}
            value={(value && value.title) ? value.title : null}
            onClick={e => setChoosingLocation({})}
            onFocus={e => setChoosingLocation({})}
            variant={variant}
            disabled={!!choosingLocation}
        />

        <LocationDialog
            onChange={data => setChoosingLocation(cl => ({...cl, ...data}))}
            onCancel={() => setChoosingLocation(null)}
            data={choosingLocation}
            onSubmit={handleChooseLocation}
        />
    </div>
}

export default InputLocation